import timedFetch from 'middleware/timedFetch';
import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { Product } from 'constants/searchTypes';
import marketplace from 'cfg/marketplace.json';

//https://confluence.zappos.net/display/MKTECH/New+Endpoint+-+API+Documentation
export enum PLACEMENT {
  CONTINUOUS_BLOCK_TOP = 'Continuous_block_top',
  CONTINUOUS_BLOCK_BOTTOM = 'Continuous_block_bottom'
}

export type RequestSponsoredAdsBody = {
  isMobile: boolean;
  sessionId: string;
  clientIp?: string;
  url: string;
  titleTag: string;
  term?: string;
  keywords: string[];
  pageType: string;
  recommendationType?: string;
  stockId?: string;
  filters?: Partial<RequestSponsoredAdsBodyFilters>;
  placementId?: PLACEMENT;
  minRes: number;
  maxRes: number;
  engines?: string[];
};

export type RequestSponsoredAdsBodyFilters = {
  brandNameFacet: string[];
  brandId: string[];
  colorFacet: string[];
  hc_footwear_infant_toddler_youth_size: string[];
  hc_men_size: string[];
  hc_women_size: string[];
  onSale: string[];
  price: number[];
  priceFacet: number[];
  realBrandNameFacet: string[];
  txAttrFacet_Features: string[];
  txAttrFacet_Gender: string[];
  txAttrFacet_Occasion: string[];
  txAttrFacet_SleeveLength: string[];
  txAttrFacet_Styles: string[];
  txAttrFacet_Verticals: string[];
  zc1: string[];
  zc2: string[];
  zc3: string[];
  zc4: string[];
  zc5: [string];
};

export interface SponsoredAdsResults {
  impressionUrl: string;
  results: SponsoredAdProduct[];
}

export interface SponsoredAdsResponse {
  [engine: string]: SponsoredAdsResults;
}

export interface SponsoredAdProduct extends Product {
  viewUrl: string;
  impressionUrl: string;
}

export function getSponsoredAds(
  body: RequestSponsoredAdsBody,
  controller: AbortController,
  fetcher = timedFetch('getSponsoredAds')
): Promise<SponsoredAdsResponse> {
  const {
    api: {
      sponsoredAds: { url }
    }
  } = marketplace;
  const opts = {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'Accept': '*/*'
    },
    body: JSON.stringify(body),
    signal: controller.signal
  };

  return fetcher(`${url}/sponsored-ads/adEngines`, opts).then(fetchErrorMiddleware);
}
